define((require) => {
    "use strict";

    var AbstractGuidelineView = require("ui/editor/guideline/AbstractGuidelineView"),
        GuidelineModel        = require("ui/editor/guideline/GuidelineModel"),
        template              = require("ui/editor/guideline/VerticalGuidelineView.tpl");

    return AbstractGuidelineView.extend("VerticalGuidelineView", {
        className: "vertical-guideline",
        template: template,

        initialize: function(options) {
            this.__super();
            this._rulers = options.rulers;
        },

        _getClientXY: function(e) {
            return e.clientX;
        },

        _getDirection: function() {
            return GuidelineModel.VERTICAL;
        },

        _getTopLeft: function() {
            return "left";
        },

        _getTooltipLabel: function() {
            return "x: ";
        },

        _getWidthHeight: function() {
            return "width";
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/guideline/VerticalGuidelineView.js